import React from 'react';

export default class Disclaimer extends React.Component {

    render() {
        return (
            <div>
                <p>
                The information provided in this worksheet is our best estimate of your professional charges and patient responsibility
                based on the information we currently have available and is not a guarantee of what you will be charged. Please understand
                that in many cases it is impossible to predict the final charges that will result as there are variables involved in your
                actual services such as: additional medical services or procedures resulting from physical exam by the provider, additional
                tests required by the physician, additional equipment or supplies, medications required, and/or any unusual special care or
                unexpected conditions or complications. If you have insurance, your benefits will ultimately determine the amount you owe
                (including deductibles, copay, co-insurance and out-of-pocket maximums). The estimate is specific to the date of service
                identified on this worksheet and is subject to change depending on any revision to the scheduled date of service.</p>

                <p>
                The Health First Medical Group remains dedicated to providing health care to our community with high quality, value, and
                patient satisfaction. To make your credit card payment conveniently prior to your scheduled visit, please contact our
                Central Service Organization at (321) 434-7601. For questions <em>during your visit</em>, please contact the associate who
                provided this estimate. For questions <em>after your visit</em> or to make a payment, please contact our Customer Service
                department at (321) 434-5055.</p>
            </div>
        );
    }
}